import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../core/auth/auth.service';
import { CONFIG } from '../../core/config';
import { ConfigService } from '../../core/config.service';
import { LicensingService } from '../../core/licensing/licensing.service';
import { SpinnerService } from '../../core/spinner/spinner.service';
import { DashboardService } from '../../views/dashboard/dashboard.service';
import { UserCatalogItem } from './user-catalog';
import { UserCatalogService } from './user-catalog.service';

@Component({
  selector: 'hb-catalog-selector',
  templateUrl: './catalog-selector.component.html',
  styleUrls: ['./catalog-selector.component.css'],
})

export class CatalogSelectorComponent implements OnInit, OnDestroy {
  @Input() changeAction: boolean;
  @Output() onChanged: EventEmitter<string> = new EventEmitter();

  private unsubscribe: Subject<boolean> = new Subject();
  constructor(private uservice: UserCatalogService,
    private authService: AuthService,
    private configService: ConfigService,
    private router: Router,
    private dashboardService: DashboardService,
    private licenseService: LicensingService,
    private spinner: SpinnerService) { }

  public selectedCatalog: UserCatalogItem;
  public catalogList: UserCatalogItem[];

  public ngOnInit(): void {
    this.uservice.GetUserCatalogs();

    this.uservice.catalogList.pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      this.catalogList = result;
      this.configService.selectedCatalog.subscribe(catalog => {
        if (this.catalogList.length > 0 && catalog) {
          this.selectedCatalog = this.catalogList.filter(x => x.catalogName == catalog)[0];
        }
      })
    });
  }

  public onCatalogChanged(e: { value: UserCatalogItem; originalEvent: PointerEvent }) {
    this.spinner.show();
    this.authService.setCatalog(e.value.catalogName);
    this.authService.setpermissions();
    this.licenseService.getCurrentLicence();
    this.dashboardService.initialiseDashboardData();
    this.spinner.hide();
    this.router.navigateByUrl(this.authService.urlCatalog + CONFIG.routes.dashboard);
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }
}
